import { Avatar, InitialsAvatar } from '@/components/ui/Avatar';
import { cn } from '@/lib/utils';

import { useWikiPersonOfUser } from '../use-wiki-person-of-user';

/** The photo of the user's People Wiki page for a Littlebird user, or the initials of the account name when the user has
 * no page for them or the page has no photo. `className` styles the chip, as on `InitialsAvatar`. */
export const WikiUserAvatar = ({
  userId,
  name,
  className,
}: {
  userId: number;
  name: string;
  className?: string;
}) => {
  const person = useWikiPersonOfUser(userId);
  const shownName = person?.name ?? name;
  return (
    <Avatar
      avatarUrl={person?.avatarUrl}
      alt={shownName}
      imageClassName={cn(
        'size-7 shrink-0 select-none rounded-full border border-border object-cover',
        className
      )}
      fallback={
        <InitialsAvatar
          name={shownName}
          seed={String(userId)}
          className={className}
        />
      }
    />
  );
};
